import { render, staticRenderFns } from "./UpdateIntent.vue?vue&type=template&id=771e0198&"
import script from "./UpdateIntent.vue?vue&type=script&lang=js&"
export * from "./UpdateIntent.vue?vue&type=script&lang=js&"
import style0 from "./UpdateIntent.vue?vue&type=style&index=0&id=771e0198&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports